import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import {
  setPropertyAsFavoriteAction,
  removePropertyFromFavoritesAction,
} from '@state/favorites/favorites.actions';
import { selectAuthToken } from '@state/auth/auth.selectors';

import { IProperty } from '@shared/models/properties';
import { FeatureFlagsService } from '@core/services/feature-flags.service';

@UntilDestroy()
@Component({
  selector: 'app-shared-favorite-property',
  templateUrl: './favorite-property.component.html',
  styleUrls: ['./favorite-property.component.scss'],
})
export class FavoritePropertyComponent implements OnInit {
  @Input() property?: IProperty;
  @Input() iconSize = 28;
  @Input() full = false;

  protected isLoggedIn = false;

  constructor(
    private store: Store<AppState>,
    private featureFlagsService: FeatureFlagsService
  ) {}

  ngOnInit(): void {
    this.store
      .select(selectAuthToken)
      .pipe(untilDestroyed(this))
      .subscribe((token) => {
        this.isLoggedIn = !!token;
      });
  }

  handleFavorite(e: Event) {
    if (!this.property) return;
    if (this.property.isFavorite) {
      this.store.dispatch(
        removePropertyFromFavoritesAction({ propertyId: this.property.id })
      );
    } else {
      this.store.dispatch(
        setPropertyAsFavoriteAction({ propertyId: this.property.id })
      );
    }
  }
}
